export const MuiButton = {
	defaultProps: {
		variant: "default",
		disableRipple: true,
	},
	variants: [
		{
			props: { variant: "default" },
			style: ({ theme }) => {
				let colors = theme.palette;
				return {
					border: `1px solid transparent`,
					color: "var(--white)",
					"&:disabled": {
						color: "rgba(255,255,255,.6)",
					},
				};
			},
		},
		{
			props: { variant: "default", color: "primary" },
			style: ({ theme }) => {
				let colors = theme.palette;
				return {
					backgroundColor: colors.primary.main,
					"&:hover": {
						border: `1px solid ${colors.primary.main}`,
						backgroundColor: "transparent",
						color: `${colors.primary.main}`,
					},
					"&:disabled": {
						backgroundColor: colors.primary.dark,
					},
				};
			},
		},
		{
			props: { variant: "default", color: "secondary" },
			style: ({ theme }) => {
				let colors = theme.palette;
				let mode = theme.palette.mode;
				return {
					backgroundColor: colors.secondary.main,
					color: "var(--white)",
					"&:hover": {
						border: `1px solid ${colors.secondary.main}`,
						backgroundColor: "transparent",
						color: `${mode === "light" ? colors.secondary.main : colors.common.white}`,
					},
					"&:disabled": {
						backgroundColor: colors.secondary.dark,
					},
				};
			},
		},
		{
			props: { variant: "default", color: "error" },
			style: ({ theme }) => {
				let colors = theme.palette;
				return {
					backgroundColor: colors.error.main,
					"&:hover": {
						border: `1px solid ${colors.error.main}`,
						backgroundColor: "transparent",
						color: `${colors.error.main}`,
					},
					"&:disabled": {
						backgroundColor: colors.error.dark,
					},
				};
			},
		},
		{
			props: { variant: "default", color: "warning" },
			style: ({ theme }) => {
				let colors = theme.palette;
				return {
					backgroundColor: colors.warning.main,
					"&:hover": {
						border: `1px solid ${colors.warning.main}`,
						backgroundColor: "transparent",
						color: `${colors.warning.main}`,
					},
					"&:disabled": {
						backgroundColor: colors.warning.dark,
					},
				};
			},
		},
		{
			props: { variant: "default", color: "info" },
			style: ({ theme }) => {
				let colors = theme.palette;
				return {
					backgroundColor: colors.info.main,
					"&:hover": {
						border: `1px solid ${colors.info.main}`,
						backgroundColor: "transparent",
						color: `${colors.info.main}`,
					},
					"&:disabled": {
						backgroundColor: colors.info.dark,
					},
				};
			},
		},
		{
			props: { variant: "default", color: "success" },
			style: ({ theme }) => {
				let colors = theme.palette;
				return {
					backgroundColor: colors.success.main,
					"&:hover": {
						border: `1px solid ${colors.success.main}`,
						backgroundColor: "transparent",
						color: `${colors.success.main}`,
					},
					"&:disabled": {
						backgroundColor: colors.success.dark,
					},
				};
			},
		},
	],
};
